import { Grid } from '@mui/material';

import { FunctionComponent, ReactNode } from 'react';

import '../styles/ContactInfoDisplay.scss';

interface Props {
  label: string;
  children: ReactNode;
}

export const ContactInfoDisplay: FunctionComponent<Props> = props => {
  return (
    <Grid container className="contact-info-display">
      <Grid item xs={12} md={6} lg={3} xl={5} className="contact-info-display__label">
        {props.label}:
      </Grid>
      <Grid item xs={12} md={6} lg={8} xl={7} className="contact-info-display__value">
        {props.children}
      </Grid>
    </Grid>
  );
};
